import { ChangeEvent, FC, useEffect, useRef, useState } from 'react'
import { KTCard } from '../../../../../../../_metronic/helpers'
import { Button } from '../../../../../components/UI/Button'
import Poppup from '../../../../../components/UI/Poppup'
import { useHoteleria } from '../../../../../hooks/useHoteleria'
import { TabModel } from '../../../../../models'
import { getSnackBarToast } from '../../../../../util/snackBar'
import { ModalErrorUpload } from '../../../../central/pages/componentes/Modal/ModalErrorUpload'
import {
  getPlantillaReimpresionCheckinMasiveDownloadUrl,
  postDownloadPDFReimpresionCheckInPorDnisExcelService,
} from '../../../services/booking.service'

const CheckInListMasiveTab: FC = () => {
  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState('')
  const { changeCurrentTabItem, currentTabItem } = useHoteleria()
  const [show, setShow] = useState(false)
  const [response, setResponse] = useState('')
  const [progress, setProgress] = useState(0)
  const [titleUpload, setTitleUpload] = useState('')
  const [showPoppup, setShowPoppup] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const [loading, setLoading] = useState(false)
  const completeIntervalRef = useRef<number | null>(null)

  const handleGetTemplate = () => {
    try {
      const url = getPlantillaReimpresionCheckinMasiveDownloadUrl()
      const link = document.createElement('a')
      link.href = url
      link.download = 'PLANTILLA_REIMPRESION_CHECKIN.xlsx'
      link.target = '_blank'
      link.rel = 'noopener noreferrer'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch {
      getSnackBarToast('Hubo un error al descargar la plantilla', 'error')
    }
  }

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setError('')
    setProgress(0)
  }

  const handleClosePoppup = () => {
    if (completeIntervalRef.current !== null) {
      clearInterval(completeIntervalRef.current)
      completeIntervalRef.current = null
    }
    setFile(null)
    setShowPoppup(false)
    setLoading(false)
  }

  const handleUpload = async () => {
    let keepFileOnError = false
    try {
      if (!file) {
        changeCurrentTabItem({ ...currentTabItem, trayUpdated: false })
        setError('Este campo es requerido')
        return
      }

      const originalName = file.name
      const ext = originalName.substring(originalName.lastIndexOf('.'))
      const base = originalName.substring(0, originalName.lastIndexOf('.'))
      const newBase = base.substring(0, 40)
      const newName = `${newBase}${ext}`
      const newFile = new File([file], newName, { type: file.type })

      setError('')
      const formData = new FormData()
      formData.append('test', newFile)
      changeCurrentTabItem({ ...currentTabItem, trayUpdated: false })
      setLoading(true)
      setShowPoppup(true)
      setTitleUpload('Generando PDF, espere...')
      setProgress(0)

      const response = await postDownloadPDFReimpresionCheckInPorDnisExcelService(formData)
      const buffer = response.data as ArrayBuffer
      const arr = new Uint8Array(buffer)
      const header =
        arr.length >= 4
          ? String.fromCharCode(arr[0], arr[1], arr[2], arr[3])
          : ''

      if (header === '%PDF') {
        const blob = new Blob([buffer], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `ReimpresionCheckIn-${new Date().toISOString().replace(/[:.]/g, '-')}.pdf`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(link.href)
        getSnackBarToast('PDF generado correctamente', 'success')
      } else {
        keepFileOnError = true
        try {
          const text = new TextDecoder().decode(buffer)
          const json = JSON.parse(text)
          const msg =
            json?.message ||
            json?.Message ||
            json?.msg ||
            json?.MsgError ||
            json?.error ||
            text
          setResponse(typeof msg === 'string' ? msg : JSON.stringify(msg))
        } catch {
          setResponse('No se pudo interpretar la respuesta del servidor')
        }
        setShow(true)
      }
    } catch (err: any) {
      keepFileOnError = true
      let message = 'Hubo un error al procesar el archivo'
      const data = err?.response?.data
      if (data instanceof ArrayBuffer) {
        try {
          const text = new TextDecoder().decode(new Uint8Array(data))
          const json = JSON.parse(text)
          message =
            (typeof json?.message === 'string' && json.message) ||
            (typeof json?.Message === 'string' && json.Message) ||
            (typeof json?.msg === 'string' && json.msg) ||
            json?.MsgError?.toString() ||
            message
        } catch {
          /* mantener mensaje por defecto */
        }
      }
      setResponse(message)
      setShow(true)
      getSnackBarToast(message, 'error')
    } finally {
      if (completeIntervalRef.current !== null) {
        clearInterval(completeIntervalRef.current)
        completeIntervalRef.current = null
      }
      setLoading(false)
      setShowPoppup(false)
      setProgress(0)
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
      if (!keepFileOnError) {
        setFile(null)
      }
    }
  }

  useEffect(() => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    return () => {
      if (completeIntervalRef.current !== null) {
        clearInterval(completeIntervalRef.current)
      }
    }
  }, [])

  return (
    <KTCard shadow className='m-5'>
      <form>
        <div className='p-6'>
          <div className='d-flex'>
            <div className='col-6'>
              <div className='mb-3 col-10'>
                <Button onClick={handleGetTemplate} label='Descargar Plantilla' />
              </div>
            </div>
          </div>
          <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
            <label className='required form-label'>Examinar</label>
            <div className='input-group input-group-sm'>
              <input
                className='form-control'
                type='file'
                id='formFileCheckinMasive'
                onChange={handleFileChange}
                ref={fileInputRef}
              />
            </div>
            {showPoppup && (
              <Poppup
                progress={progress}
                text={titleUpload}
                hasClose
                handleClose={handleClosePoppup}
              />
            )}
            {error && <p className='error-message'>{error?.toString()}</p>}
          </div>
        </div>
        <div className='d-flex justify-content-center mb-3'>
          <Button onClick={handleUpload} label='Subir Archivo' disabled={loading} />
        </div>
      </form>
      <ModalErrorUpload show={show} setShow={setShow} message={response} file={file} />
    </KTCard>
  )
}

export { CheckInListMasiveTab }
